import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
@Component({
  selector: 'app-intelligence-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [{ provide: TabComponent, useExisting: IntelligenceTabComponent }],
  templateUrl: './intelligence-tab.component.html',
  styleUrl: './intelligence-tab.component.scss',
})
export class IntelligenceTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Intelligence');

  public async main(): Promise<void> {}
}
